import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import SchoolIcon from '@mui/icons-material/School';

export default function LandingAppBar() {
  return (
    <AppBar
      position="fixed"
      sx={{
        bgcolor: 'rgba(11, 15, 25, 0.8)',
        backdropFilter: 'blur(24px)',
        borderBottom: 1,
        borderColor: 'divider',
      }}
    >
      <Container maxWidth="lg">
        <Toolbar disableGutters sx={{ minHeight: { xs: 56, sm: 64 } }}>
          <SchoolIcon sx={{ color: 'primary.main', mr: 1.5, fontSize: 28 }} />
          <Typography
            variant="h3"
            component="span"
            sx={{
              color: 'text.primary',
              fontWeight: 700,
              letterSpacing: '-0.01em',
            }}
          >
            Syllabex
          </Typography>
          <Box sx={{ flexGrow: 1 }} />
        </Toolbar>
      </Container>
    </AppBar>
  );
}
